import $http from '@/libs/axios'
import FormsHelper from '@/services/forms-service'
import store from '@/store'

class AccountManagersAPI {
  private static managers: any = null;

  public static async submit(type: 'create' | 'update', body: any) {
    return (await $http.post(`/managers/${type}`, body)).data
  }

  public static async list() {
    if (store.getters['permissions/isManager']) {
      return []
    }
    return (await $http.get('/managers/list')).data
  }

  public static async delete() {
    throw new Error('Delete Account API not implemented yet!')
  }

  public static async getAccountManagersList(force = false) {
    if (AccountManagersAPI.managers && !force) {
      return AccountManagersAPI.managers
    }

    if (store.getters['permissions/isManager']) {
      return []
    }

    AccountManagersAPI.managers = (await $http.get('/managers/list')).data
    return AccountManagersAPI.managers
  }

  public static async getAccountManager(accountId: number) {
    const managers = (await $http.get('/managers/list')).data
    const manager = managers.find((manager1: any) => manager1.id === accountId)
    if (!manager) {
      throw Error('Manager not found')
    }
    return manager
  }

  public static async getReports(query: any) {
    const queryString = FormsHelper.prepareQueryString(query, true)
    return (await $http.get(`/managers/reports?${queryString}`)).data
  }
}

export default AccountManagersAPI
